import { isEqual } from 'lodash'

export const arePropsEqual = <T>(prevProps: T, nextProps: T) => {
  return isEqual(prevProps, nextProps)
}
